import { render } from "./CasesBoxElement.vue?vue&type=template&id=61d04054&scoped=true"
import script from "./CasesBoxElement.vue?vue&type=script&lang=js"
export * from "./CasesBoxElement.vue?vue&type=script&lang=js"

import "./CasesBoxElement.vue?vue&type=style&index=0&id=61d04054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d04054"]])

export default __exports__